import { useEffect, useState } from "react"
import { getMyProfileOffers } from "../../API/ApiService"
import MyOfferPopup from "./MyOfferPopup"
import { useNavigate } from "react-router"
import QRModel from "./QRModel"

const MyOffer = () => {
    const [offers, setOffers] = useState([])
    const [selectedOffer, setOpenOffer] = useState()
    const [claimOffer, setClaimOffer] = useState()
    const navigate = useNavigate();

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        getMyProfileOffers().then((res) => {
            // console.log(res);
            setOffers(res?.data?.result)
        })
    }

    return <div>
        {selectedOffer && <MyOfferPopup selectedOffer={selectedOffer} handleClose={() => setOpenOffer()} setClaimOffer={setClaimOffer} />}
        <QRModel selectedOffer={claimOffer} handleClose={() => {
            getData()
            setClaimOffer()
        }} />
        <section className="interestDiv">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <img
                            src={"../images/back_btn.png"}
                            alt="Back"
                            height={25}
                            width={76}
                            onClick={() => navigate("/")}
                            style={{ cursor: "pointer", marginTop: "35px" }}
                        />
                    </div>
                    <div
                        className="col-md-12"
                        style={{ marginTop: "30px", marginBottom: "10px" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <h2>
                                <span style={{ color: "#ffffff" }}>My Offers</span>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="nib-boxes">
            <div className="container">
                {offers?.length > 0 ? <div className="businessDetails-sales-card">
                    {offers?.map((item, index) => {
                        const { offer: { title, offerImage }, status, id } = item;
                        return (
                            <div
                                className="event-box-img"
                                style={{ position: 'relative' }}
                                key={id}
                                onClick={() => setOpenOffer(item)}
                            >
                                {status == 1 && <img src="/images/claimed-ribbon.svg" style={{ position: 'absolute', right: 0, zIndex: 1 }} />}
                                <img
                                    src={
                                        offerImage && offerImage.length > 0
                                            ? offerImage[0].image
                                            : "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
                                    }
                                    style={{
                                        objectFit: "cover",
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: "15px",
                                        filter: status == 0 ? 'none' : 'grayscale(1)'
                                    }}
                                />
                            </div>
                        )
                    })}
                </div>
                    :
                    <div className="row">
                        <div className="businessDetails-Noreview">
                            <img src="/images/offer.svg" />
                            <div className="businessDetails-Noreview-content">
                                No Offer Found! <br />
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className="for-border" />
        </section >
    </div >
}


export default MyOffer